{
  "en": {
    "announcement": {
      "actions": {
        "delete_announcement": "Delete news post",
        "edit": "Edit",
        "new": "News post",
        "pin": "Pin to top",
        "save": "Save",
        "submit": "Post",
        "unpin": "Unpin from top"
      },
      "attributes": {
        "description": "Description"
      },
      "labels": {
        "customers": "customers",
        "for": "for",
        "image_tab": "Image",
        "notSeenYet": "Not seen yet",
        "seen": "Seen",
        "seenByCount": "Seen by {count} of {total}",
        "now": "Now",
        "sharedWithPrefix": "Shared with",
        "sharedWithProject": "Shared with {units} of {project}",
        "allUnits": "all units",
        "someUnits": "some units",
        "pinned": "This announcement is shown at the top of the customer's page.",
        "pinnedBadge": "Pinned",
        "start": "Start",
        "unitsCount": "1 Unit | {count} Units",
        "video_tab": "Video",
        "youtube_video": "YouTube video URL"
      },
      "name": "Announcement",
      "placeholders": {
        "customers": {
          "none": {
            "subtitle": "Soon you'll find regular updates about the construction site on your dashboard.",
            "title": "Get your news here!"
          }
        },
        "employees": {
          "new": {
            "subtitle": "Welcome your customers or share an update about the project.",
            "title": "Create your first News Post"
          },
          "none": {
            "project_required": "Select a project",
            "selectProject": "Select a project and start creating!",
            "subtitle": "Welcome your customers or share an update about any project."
          },
          "paste_video_url": "Paste your YouTube link here"
        }
      },
      "toasts": {
        "create": "News post published",
        "delete": "News post deleted",
        "invalid_video": "This is not a valid YouTube video",
        "update": "News post has been updated"
      },
      "validation": {
        "pleaseAddContent": "Add an image, video or description"
      }
    }
  }
}
